import { React, useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import "./DashBoard.css";
import { useDispatch } from "react-redux";
import { sidebarReducer } from "../../Redux/store";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import MuiToggleButton from "@mui/material/ToggleButton";

import { styled, createTheme, ThemeProvider } from "@mui/material/styles";

import {
  Chart,
  LinearScale,
  CategoryScale,
  ArcElement,
  BarElement,
  Legend,
  Tooltip,
  Title,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { Doughnut, Pie } from "react-chartjs-2";
Chart.register(
  LinearScale,
  CategoryScale,
  ArcElement,
  BarElement,
  Legend,
  Title,
  Tooltip
);

const DashBoard = () => {
  // Dispatch function
  const dispatch = useDispatch();
  //API related selectors
  const tocken = useSelector((state) => state.AccessTocken.accessTocken);
  const msToken = useSelector((state) => state.AccessTocken.o365token);
  const token = tocken ? tocken : msToken;

  const [Chart1, setChart1] = useState("Bar");
  const [Chart2, setChart2] = useState("Bar");
  const [Chart3, setChart3] = useState("Bar");
  const [ContentLabel, setContentLabel] = useState("");
  const [ContentList, setContentList] = useState("");
  const [RoleLabel, setRoleLabel] = useState("");
  const [RoleList, setRoleList] = useState("");
  const [ContentColor1, setContentColor1] = useState("");
  const [BUCount, setBUCount] = useState(null);
  const [DivisionCount, setDivisionCount] = useState(null);
  const [AppCount, setAppCount] = useState(null);
  const [ProductCount, setProductCount] = useState(null);
  const [ContentCount, setContentCount] = useState(null);
  const [ThreeDContentCount, setThreeDContentCount] = useState(null);
  const [alignment1, setAlignment1] = useState("Bar");
  const [alignment2, setAlignment2] = useState("Bar");
  const [alignment3, setAlignment3] = useState("Bar");

  let Dummylist1 = [];
  let Dummylist2 = [];

  let DummylistRole1 = [];
  let DummylistRole2 = [];
  let dummylist3 = [];

  const ToggleButton = styled(MuiToggleButton)(({ selectedcolor }) => ({
    "&.Mui-selected, &.Mui-selected:hover": {
      color: "white",
      backgroundColor: selectedcolor,
    },
  }));

  const theme = createTheme({
    palette: {
      text: {
        primary: "#00ff00",
      },
    },
  });

  const optionsBar = {
    Plugins: {
      // Legend: {
      //   position: "left",
      //   maintainAspectRatio: false,
      // },
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: "Bargraph",
      },
    },
  };

  const data = {
    labels: ["BU", "Division", "Application", "Product"],
    datasets: [
      {
        label: "TotalCount",
        data: [BUCount, DivisionCount, AppCount, ProductCount],
        backgroundColor: ["Red", "Yellow", "Blue", "pink"],
        width: "10px",
        font: {
          size: 1,
        },
      },
    ],
  };

  const optionsPie = {
    // radius: 240,
    legend: {
      display: false,
    },
  };

  const optionsDoughnut = {
    circumference: 180,
    rotation: -90,
    legend: {
      display: false,
    },
  };

  const data1 = {
    labels: [],
    datasets: [
      {
        label: "TotalCount",
        data: [],
        backgroundColor: [],
        width: "10px",
        font: {
          size: 2,
        },
      },
    ],
  };

  const data2 = {
    labels: [],
    datasets: [
      {
        label: "TotalCount",
        data: [],
        backgroundColor: [],
        width: "10px",
        font: {
          size: 2,
        },
      },
    ],
  };

  //Header for API's
  const options = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const responseData = async () => {
    await axios
      .get(`count/count`, options)
      .then((response) => {
        if (response.status === 200) {
          setAppCount(response.data.data.Applications);

          setBUCount(response.data.data.Businessunit);
          setDivisionCount(response.data.data.Division);
          setProductCount(response.data.data.MasterProduct);
          setContentCount(ContentCount);
          setContentCount(response.data.data.Content);
          setThreeDContentCount(ThreeDContentCount);
          setThreeDContentCount(response.data.data.threedmodelContent);
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })

      .catch((err) => {
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  };
  const responseDataRole = async () => {
    await axios
      .get(`count/rolescount`, options)
      .then((response) => {
        if (response.status === 200) {
          DummylistRole1.push(Object.keys(response.data.data));
          DummylistRole2.push(Object.values(response.data.data));

          removeElementsWithValue(DummylistRole2[0], 0);

          setRoleLabel(DummylistRole1[0]);
          setRoleList(DummylistRole2[0]);
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })

      .catch((err) => {
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  };
  function removeElementsWithValue(arr, val) {
    var i = arr.length;
    while (i--) {
      if (arr[i] === val) {
        arr.splice(i, 1);
        DummylistRole1[0].splice(i, 1);
      }
    }
    return arr;
  }

  const responseDataContent = async () => {
    await axios
      .get(`count/content`, options)
      .then((response) => {
        if (response.status === 200) {
          Dummylist1.push(Object.keys(response.data.data));
          Dummylist2.push(Object.values(response.data.data));

          setContentLabel(Dummylist1[0]);
          setContentList(Dummylist2[0]);

          for (let i = 0; i < Dummylist1[0].length; i++) {
            dummylist3.push(generateRandomColor());
            setContentColor1(dummylist3);
          }
          setContentColor1(dummylist3);
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })

      .catch((err) => {
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  };

  function generateRandomColor() {
    let maxVal = 0xffffff; // 16777215
    let randomNumber = Math.random() * maxVal;
    randomNumber = Math.floor(randomNumber);
    randomNumber = randomNumber.toString(16);
    let randColor = randomNumber.padStart(6, 0);
    return `#${randColor.toUpperCase()}`;
  }
  function CapitalizeName(mainStr) {
    // const mainStr = "ADMIN_USER";
    const strL = mainStr.toLowerCase();

    const str1 = strL[0].toUpperCase();

    const finalS = strL.replace(strL[0], str1);
    const finalS2 = finalS.replaceAll("_", " ");

    return finalS2;
  }
  useEffect(() => {
    responseData();
    responseDataRole();
    responseDataContent();

    return () => {};
    // eslint-disable-next-line
  }, []);
  for (let i = 0; i < ContentList.length; i++) {
    data2.datasets[0].data[i] = ContentList[i];
    data2.labels[i] = ContentLabel[i];

    data2.datasets[0].backgroundColor[i] = ContentColor1[i];
    data.datasets[0].backgroundColor[i] = ContentColor1[i];
    data1.datasets[0].backgroundColor[i] = ContentColor1[i];
  }
  for (let i = 0; i < RoleList.length; i++) {
    data1.datasets[0].data[i] = RoleList[i];
    RoleLabel[i] = CapitalizeName(RoleLabel[i]);
    data1.labels[i] = RoleLabel[i];
  }

  function handleChange1(event, newAlignment) {
    setChart1(event.target.value);
    setAlignment1(newAlignment);
  }
  function handleChange2(event, newAlignment) {
    setChart2(event.target.value);
    setAlignment2(newAlignment);
  }
  function handleChange3(event, newAlignment) {
    setChart3(event.target.value);
    setAlignment3(newAlignment);
  }
  return (
    <div>
      {/* <h1>Dashboard</h1> */}
      <div className="App">
        <div>
          <div>
            <div
              className="row border g-0 p-0"
              style={{ backgroundColor: "#f2f3f5" }}
            >
              <div className=" d-flex justify-content-between">
                <div className="p-2 ms-2 mt-2">
                  <h5>
                    <strong>DashBoard</strong>
                  </h5>
                </div>
                <div className="dropdown">
                  <div
                    className="row align-items-center"
                    style={{
                      width: "300px",
                      height: "50px",
                      marginTop: "9px",
                      paddingRight: "53px",
                    }}
                  ></div>
                </div>
              </div>
            </div>
            <div className="container-fluid p-0">
              <div
                className="chartss d-flex flex-wrap"
                style={{
                  overflowY: "auto",
                  height: "80vh",
                  overflowX: "hidden",
                }}
              >
                {/* Chart 1 */}
                {/* <div
                  className="card mt-3 ms-3 p-1 shadow"
                  style={{ height: "400px", width: "450px" }}
                >
                  <div
                    className="d-flex align-items-center px-1"
                    style={{ height: "50px" }}
                  >
                    <h6 className="me-auto pt-2">
                      <strong>Organization Statistics</strong>
                    </h6>
                    <ThemeProvider theme={theme}>
                      <ToggleButtonGroup
                        color="primary"
                        value={alignment1}
                        exclusive
                        onChange={handleChange1}
                        aria-label="Platform"
                      >
                        <ToggleButton
                          value="Bar"
                          style={{
                            height: "30px",
                            fontSize: "15px",
                          }}
                          selectedcolor="#00abc0"
                          className="toggle-ColorChange"
                        >
                          Bar
                        </ToggleButton>
                        <ToggleButton
                          value="Pie"
                          style={{
                            height: "30px",
                            fontSize: "15px",
                          }}
                          selectedcolor="#00abc0"
                          className="toggle-ColorChange"
                        >
                          Pie
                        </ToggleButton>
                        <ToggleButton
                          value="Doughnut"
                          style={{
                            height: "30px",
                            fontSize: "15px",
                          }}
                          selectedcolor="#00abc0"
                          className="toggle-ColorChange"
                        >
                          Doughnut
                        </ToggleButton>
                      </ToggleButtonGroup>
                    </ThemeProvider>
                  </div>
                  {Chart1 === "Bar" && (
                    <div className="card-body d-flex justify-content-center">
                      <Bar
                        options={optionsBar}
                        data={data}
                        height="350px"
                        width="500px"
                      />
                    </div>
                  )}
                  {Chart1 === "Pie" && (
                    <div className="card-body d-flex justify-content-center">
                      <Pie
                        data={data}
                        options={optionsPie}
                        height="350px"
                        width="500px"
                      />
                    </div>
                  )}
                  {Chart1 === "Doughnut" && (
                    <div className="card-body d-flex justify-content-center">
                      <Doughnut
                        data={data}
                        options={optionsDoughnut}
                        height="350px"
                        width="500px"
                      />
                    </div>
                  )}
                </div> */}
                {/* Chart 2 */}
                {/* <div
                  className="card mt-3 ms-3 p-1 shadow"
                  style={{ height: "400px", width: "450px" }}
                >
                  <div
                    className="d-flex align-items-center px-1"
                    style={{ height: "50px" }}
                  >
                    <h6 className="me-auto pt-2">
                      <strong>User Statistics</strong>
                    </h6>
                    <ThemeProvider theme={theme}>
                      <ToggleButtonGroup
                        color="primary"
                        value={alignment2}
                        exclusive
                        onChange={handleChange2}
                      >
                        <ToggleButton
                          value="Bar"
                          style={{
                            height: "30px",
                            fontSize: "15px",
                          }}
                          selectedcolor="#00abc0"
                        >
                          Bar
                        </ToggleButton>
                        <ToggleButton
                          value="Pie"
                          style={{
                            height: "30px",
                            fontSize: "15px",
                          }}
                          selectedcolor="#00abc0"
                        >
                          Pie
                        </ToggleButton>
                        <ToggleButton
                          value="Doughnut"
                          style={{
                            height: "30px",
                            fontSize: "15px",
                          }}
                          selectedcolor="#00abc0"
                        >
                          Doughnut
                        </ToggleButton>
                      </ToggleButtonGroup>
                    </ThemeProvider>
                  </div>
                  {Chart2 === "Bar" && (
                    <div className="card-body d-flex justify-content-center">
                      <Bar
                        options={optionsBar}
                        data={data1}
                        height="350px"
                        width="500px"
                      />
                    </div>
                  )}
                  {Chart2 === "Pie" && (
                    <div className="card-body d-flex justify-content-center">
                      <Pie
                        data={data1}
                        options={optionsPie}
                        height="350px"
                        width="500px"
                      />
                    </div>
                  )}
                  {Chart2 === "Doughnut" && (
                    <div className="card-body d-flex justify-content-center">
                      <Doughnut
                        data={data1}
                        options={optionsDoughnut}
                        height="350px"
                        width="500px"
                      />
                    </div>
                  )}
                </div> */}
                {/* Chart 3 */}
                <div
                  className="card mt-3 ms-3 p-1 shadow"
                  style={{ height: "400px", width: "450px" }}
                >
                  <div
                    className="d-flex align-items-center px-1"
                    style={{ height: "50px" }}
                  >
                    <h6 className="me-auto pt-2">
                      <strong>Contents Statistics</strong>
                    </h6>
                    <ThemeProvider theme={theme}>
                      <ToggleButtonGroup
                        color="primary"
                        value={alignment3}
                        exclusive
                        onChange={handleChange3}
                      >
                        <ToggleButton
                          value="Bar"
                          style={{
                            height: "30px",
                            fontSize: "15px",
                          }}
                          selectedcolor="#009900"
                        >
                          Bar
                        </ToggleButton>
                        <ToggleButton
                          value="Pie"
                          style={{
                            height: "30px",
                            fontSize: "15px",
                          }}
                          selectedcolor="#009900"
                        >
                          Pie
                        </ToggleButton>
                        <ToggleButton
                          value="Doughnut"
                          style={{
                            height: "30px",
                            fontSize: "15px",
                          }}
                          selectedcolor="#009900"
                        >
                          Doughnut
                        </ToggleButton>
                      </ToggleButtonGroup>
                    </ThemeProvider>
                  </div>
                  {Chart3 === "Bar" && (
                    <div className="card-body d-flex justify-content-center">
                      <Bar
                        options={optionsBar}
                        data={data2}
                        height="350px"
                        width="500px"
                      />
                    </div>
                  )}
                  {Chart3 === "Pie" && (
                    <div className="card-body d-flex justify-content-center">
                      <Pie
                        data={data2}
                        options={optionsPie}
                        height="350px"
                        width="500px"
                      />
                    </div>
                  )}
                  {Chart3 === "Doughnut" && (
                    <div className="card-body d-flex justify-content-center">
                      <Doughnut
                        data={data2}
                        options={optionsDoughnut}
                        height="350px"
                        width="500px"
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashBoard;
